import React, { useState, useEffect } from "react";

/* eslint-disable import/no-duplicates */
import { format, addMonths, subMonths, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
/* eslint-enable import/no-duplicates */

import styled from "styled-components";
import { Button } from "react-bootstrap";
import { RightArrowOutlineIcon } from "../Icons";

type Evento = {
    titulo: string;
    data: string;
};

type FechamentoMes = {
    justificar: string;
    aprovar: string;
};

type EventosMes = {
    feriados: Evento[];
    fechamentoMes: FechamentoMes;
};

const mockBuscarEventos = async (mes: number, ano: number) => {
    return {
        feriados: [
            { titulo: "Dia de finados", data: "02/11" },
            { titulo: "Proclamação da República", data: "15/11" },
            { titulo: "Dia da Consciência Negra", data: "20/11" },
            { titulo: "TDE - Campus Curitiba", data: "20/11" },
        ],
        fechamentoMes: {
            justificar: "04/11",
            aprovar: "06/11",
        },
    };
};

const Title = styled.h2`
    color: #585858;
    font-family: Poppins;
    font-weight: 500;
    font-size: 24px;
    line-height: 140%;
    letter-spacing: 0px;
`;

const Container = styled.div`
    background: #ffffff;
    margin-top: 24px;
    padding: 24px;
    width: 574;
    height: 433;
    gap: 24px;
    padding: 24px;
    border-radius: 24px;
    border-width: 1px;
    border: 1px solid #f0f2f2;
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    height: 32px;
    justify-content: space-between;
    background-color: #e4e4e4;
    border-radius: 8px;
    padding-top: 4px;
    padding-right: 8px;
    padding-bottom: 4px;
    padding-left: 8px;
`;

const ButtonChangeDataIcon = styled.button`
    width: 20px;
    height: 24px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const DataBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const DataItem = styled.span`
    font-family: "Red Hat Text";
    font-weight: 600;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0%;
    text-transform: capitalize;
`;

const ListaFeriados = styled.ul`
    margin-top: 16px;
    max-height: 400px;
    overflow-y: auto;
    padding-right: 8px;

    /* Estilização opcional da barra de rolagem */
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 4px;
    }
`;

const FeriadoItem = styled.li`
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
`;

const FeriadoTexto = styled.span`
    font-family: Source Sans Pro;
    font-weight: 400;
    font-size: 15px;
    line-height: 156%;
    letter-spacing: 0px;
    color: #404040;
`;

const Section = styled.div`
    margin-top: 24px;
    text-align: center;
`;

const FechamentoMesTexto = styled.div`
    margin-top: 32px;
    font-family: Source Sans Pro;
    font-weight: 400;
    font-size: 15px;
    line-height: 156%;
    letter-spacing: 0px;
    text-align: center;
    color: #585858;
    background: #fafafa;
    border-radius: 8px;
    padding-top: 4px;
    padding-right: 8px;
    padding-bottom: 4px;
    padding-left: 8px;
`;

const FechamentoBox = styled.div`
    margin-top: 16px;
    padding: 12px;
    border-radius: 4px;
`;

const DataTexto = styled.div`
    border-radius: 8px;
    padding-top: 4px;
    padding-right: 8px;
    padding-bottom: 4px;
    padding-left: 8px;
    text-transform: capitalize;
`;

const Linha = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
`;

const FechamentoTexto = styled.span`
    font-family: Source Sans Pro;
    font-weight: 400;
    font-size: 15px;
    line-height: 156%;
    letter-spacing: 0px;
    color: #404040;
`;

export interface Holiday {
    calendarioFeriadoId: number;
    dataFeriado: string;
    tipoFeriado: string;
    nomeFeriado: string;
    motivoRecesso: string;
    campus: string;
}

export interface GestaoAtividade {
    calendarioGestaoAtividadesId: number;
    created: string;
    updated: string;
    kind: string;
    selfLink: string;
    dataSelecionadaNoCalendario: string;
    periodoInicioReferencia: string;
    periodoFimReferencia: string;
    dataLimiteJustificativa: string;
    dataLimiteAprovacao: string;
    matriculaQuemInseriu: string;
    nomeQuemInseriu: string;
}

type CalendarComponentProps = {
    holidaysData: Holiday[];
    gestaoAtividadeData: GestaoAtividade[];
    onChangeMes: (mes: number, ano: number) => void;
};

const Calendario = ({
    holidaysData,
    gestaoAtividadeData,
    onChangeMes,
}: CalendarComponentProps) => {
    const [dataAtual, setDataAtual] = useState(new Date());

    const handleMesAnterior = () => {
        const novaData = subMonths(dataAtual, 1);
        setDataAtual(novaData);

        const novoMes = novaData.getMonth() + 1;
        const novoAno = novaData.getFullYear();

        onChangeMes(novoMes, novoAno);
        // setDataAtual(subMonths(dataAtual, 1));
    };

    const handleMesProximo = () => {
        // setDataAtual(addMonths(dataAtual, 1));

        const novaData = addMonths(dataAtual, 1);
        setDataAtual(novaData);

        const novoMes = novaData.getMonth() + 1;
        const novoAno = novaData.getFullYear();

        onChangeMes(novoMes, novoAno); // chama a função do pai com o novo mês e ano
    };

    const ano = format(dataAtual, "yyyy", { locale: ptBR });
    const mes = format(dataAtual, "MMMM", { locale: ptBR });

    return (
        <div>
            <Title>Calendário</Title>
            <Container>
                <Header>
                    <ButtonChangeDataIcon
                        type="button"
                        onClick={handleMesAnterior}
                        aria-label="Mês anterior"
                    >
                        <RightArrowOutlineIcon
                            style={{
                                width: "5px",
                                height: "10px",
                                borderWidth: "2px",
                                marginRight: "auto",
                                transform: "scaleX(-1)",
                            }}
                        />
                    </ButtonChangeDataIcon>
                    <DataBox>
                        <DataItem
                            style={{
                                marginRight: "32px",
                            }}
                        >
                            {mes}
                        </DataItem>
                        <DataItem>{ano}</DataItem>
                    </DataBox>
                    <ButtonChangeDataIcon
                        type="button"
                        onClick={handleMesProximo}
                        aria-label="Mês seguinte"
                    >
                        <RightArrowOutlineIcon
                            style={{
                                width: "5px",
                                height: "10px",
                                borderWidth: "2px",
                                marginLeft: "auto",
                            }}
                        />
                    </ButtonChangeDataIcon>
                </Header>

                {holidaysData && holidaysData.length > 0 ? (
                    <ListaFeriados>
                        {holidaysData.map((feriado) => (
                            <FeriadoItem key={feriado.calendarioFeriadoId}>
                                <FeriadoTexto>
                                    {feriado.campus
                                        ? `${feriado.nomeFeriado} - ${feriado.campus}`
                                        : feriado.nomeFeriado}
                                </FeriadoTexto>
                                <FeriadoTexto>
                                    {format(
                                        parseISO(feriado.dataFeriado),
                                        "dd/MM"
                                    )}
                                </FeriadoTexto>
                            </FeriadoItem>
                        ))}
                    </ListaFeriados>
                ) : (
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                        Nenhum registro para o período selecionado.
                    </div>
                )}

                <Section>
                    <FechamentoMesTexto>Fechamento do mês</FechamentoMesTexto>
                    <DataTexto>{mes}</DataTexto>
                </Section>

                <FechamentoBox>
                    <Linha>
                        <FechamentoTexto>
                            Prazo limite para justificar
                        </FechamentoTexto>
                        <FechamentoTexto>
                            {gestaoAtividadeData.length > 0 &&
                            gestaoAtividadeData[0]?.dataLimiteJustificativa ? (
                                format(
                                    parseISO(
                                        gestaoAtividadeData[0]
                                            .dataLimiteJustificativa
                                    ),
                                    "dd/MM"
                                )
                            ) : (
                                <strong>Não parametrizado</strong>
                            )}
                        </FechamentoTexto>
                    </Linha>
                    <Linha>
                        <FechamentoTexto>
                            Prazo limite para aprovar
                        </FechamentoTexto>
                        <FechamentoTexto>
                            {gestaoAtividadeData.length > 0 &&
                            gestaoAtividadeData[0]?.dataLimiteAprovacao ? (
                                format(
                                    parseISO(
                                        gestaoAtividadeData[0]
                                            .dataLimiteAprovacao
                                    ),
                                    "dd/MM"
                                )
                            ) : (
                                <strong>Não parametrizado</strong>
                            )}
                        </FechamentoTexto>
                    </Linha>
                </FechamentoBox>
            </Container>
        </div>
    );
};

export default Calendario;
